// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__qkDNB","footerLogo":"Logo_footerLogo__DoCUD","headerLogo":"Logo_headerLogo__ZxGvS","dashboardHeaderLogo":"Logo_dashboardHeaderLogo__W7GLV"};